import React from 'react';
import { Section, Eyebrow, H2, Reveal, DataTable, Ref, FONT, MONO } from './ui';

export const Agenda = ({ d, L, t }) => (
  <Section id="agenda" dark>
    <Reveal><Eyebrow dark>{t.today}</Eyebrow><H2 dark className="mt-4">{L(d.agenda.title)}</H2></Reveal>
    <div className="mt-14 relative" data-testid="agenda-timeline-container">
      <div className="absolute left-[4.5rem] sm:left-24 top-0 bottom-0 w-px bg-gradient-to-b from-blue-500 via-blue-400/40 to-transparent" />
      {d.agenda.items.map((a, i) => (
        <Reveal key={a.time} delay={i * 70}>
          <div className="relative flex items-center gap-6 sm:gap-10 py-4 group" data-testid={`agenda-item-${i}`}>
            <span className="w-14 sm:w-20 text-right text-lg sm:text-2xl font-bold text-blue-200 tabular-nums" style={MONO}>{a.time}</span>
            <span className="relative z-10 w-3.5 h-3.5 rounded-full bg-blue-500 ring-4 ring-[#060d24] group-hover:scale-150 transition-transform" />
            <div className="flex-1 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4 group-hover:bg-white/[0.07] group-hover:border-blue-400/40 transition-colors">
              <p className="text-lg font-bold" style={FONT}>{L(a.block)}</p>
              <p className="text-sm text-blue-300">{L(a.you)}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);

export const Toolkit = ({ d, L, t }) => (
  <Section id="toolkit" className="bg-slate-50">
    <Reveal><Eyebrow>Toolkit</Eyebrow><H2 className="mt-4">{t.toolkitTitle}</H2></Reveal>
    <div className="mt-14 grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-10">
      <Reveal>
        <p className="text-sm font-bold text-slate-500 mb-3" style={MONO}>01 · {L(d.symbols.title)}</p>
        <div className="grid sm:grid-cols-2 gap-3" data-testid="ipa-symbols-table">
          {d.symbols.rows.map((r) => (
            <div key={r.sym} className="rounded-2xl bg-white border border-slate-200 p-4 hover:border-blue-400 hover:shadow-lg transition-[box-shadow,border-color]">
              <div className="flex items-baseline gap-3"><span className="text-3xl font-semibold text-blue-600" style={MONO}>{r.sym}</span><span className="text-sm font-bold text-slate-800">{r.as}</span></div>
              <p className="mt-2 text-sm text-slate-600">{L(r.feel)}</p>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs text-slate-500">{L(d.symbols.note)}</p>
      </Reveal>
      <Reveal delay={120}>
        <p className="text-sm font-bold text-slate-500 mb-3" style={MONO}>02 · {L(d.lexical.title)}</p>
        <DataTable cols={d.lexical.cols} rows={d.lexical.rows} testid="lexical-sets-table" />
        <p className="mt-4 text-xs text-slate-500">{L(d.lexical.note)}</p>
      </Reveal>
    </div>
    <Reveal>
      <p className="mt-16 text-sm font-bold text-slate-500 mb-3" style={MONO}>03 · {L(d.prosody.title)}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="prosody-cues">
        {d.prosody.items.map((p, i) => (
          <div key={i} className="rounded-3xl bg-[#060d24] text-white p-6 relative overflow-hidden">
            <span className="absolute -right-3 -bottom-6 text-8xl font-extrabold text-white/5" style={FONT}>{i + 1}</span>
            <p className="text-lg font-bold" style={FONT}>{L(p.title)}</p>
            <p className="mt-2 text-sm text-blue-100/75">{L(p.body)}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 rounded-2xl border border-blue-200 bg-blue-50 p-5 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-xl font-bold text-blue-900" style={FONT}>“{d.prosody.demo}”</p>
        <p className="text-sm text-blue-900/70 md:ml-auto max-w-xl">{L(d.prosody.ohala)}</p>
      </div>
      <div className="mt-3"><Ref>Ohala, J. (1984), Phonetica 41 · Wells, J. C. (1982), Accents of English</Ref></div>
    </Reveal>
  </Section>
);
